import { useCallback, useEffect } from 'react';
import { Box, FormControl, Select, MenuItem } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import ClearIconML from '@/components/ClearIconML/index';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'dva';

export default () => {
  const { setValue, watch, control } = useForm({
    defaultValues: {
      type: '',
    },
  });
  const handleClearAuthor = () => {
    setValue('permittedGroup', '');
    setType(null);
  };

  const watchAuthor = watch('permittedGroup');
  const { highFrequencyUser, highFrequencyFunction, allRole } =
    useSelector((state) => state.behaviorData) || {};
  const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
  const dispatch = useDispatch();
  const [type, setType] = React.useState();
  //高频用户top
  const queryHighFrequencyUser = useCallback(() => {
    dispatch({
      type: 'behaviorData/queryHighFrequencyUser',
      payload: {
        queryDate: yesterday,
        topNum: 5,
        permittedGroup: type,
      },
    });
  }, [dispatch, type, yesterday]);
  useEffect(() => {
    queryHighFrequencyUser();
  }, [queryHighFrequencyUser]);

  const handleChange = (event) => {
    setType(event.target.value);
    setValue('permittedGroup', event.target.value);
  };
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box mb={3} className="info-style" flex="1">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" flex="1">
            高频用户Top5
            {/* <TooltipML info="这里是一段文字描述" /> */}
          </Box>
          <FormControl sx={{ height: 'auto' }}>
            <Controller
              render={(rp) => (
                <Select
                  value={rp.value}
                  onChange={handleChange}
                  name="permittedGroup"
                  variant="standard"
                  sx={{ height: 'auto', width: '200px' }}
                >
                  {allRole && allRole.length > 0 ? (
                    allRole.map((item) => (
                      <MenuItem key={item.id} value={item.id} name={item.id}>
                        {item.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>暂无数据</MenuItem>
                  )}
                </Select>
              )}
              name="permittedGroup"
              variant="standard"
              control={control}
              defaultValue=""
            />

            <ClearIconML
              handleClick={handleClearAuthor}
              clearValue={watchAuthor}
            ></ClearIconML>
          </FormControl>
        </Box>
        <Box mt={2}>
          {highFrequencyUser?.map((item, index) => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  gap: '24px',
                  margin: '22px 0',
                }}
                key={item?.num}
              >
                <Box
                  sx={{
                    width: '18px',
                    height: '18px',
                    textAlign: 'center',
                    lineHeight: '18px',
                    background: index < 3 ? 'rgb(21, 101, 192)' : '#ccc',
                    color: '#fff',
                    borderRadius: '2px',
                  }}
                >
                  {index + 1}
                </Box>
                <Box sx={{ color: '#333' }}>{item?.name || '-'}</Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      <Box className="info-style" flex="1">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" flex="1">
            热门功能Top5
            {/* <TooltipML info="这里是一段文字描述" /> */}
          </Box>
        </Box>
        <Box mt={2}>
          {highFrequencyFunction?.map((item, index) => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  gap: '24px',
                  margin: '22px 0',
                }}
                key={item?.num}
              >
                <Box
                  sx={{
                    width: '18px',
                    height: '18px',
                    textAlign: 'center',
                    lineHeight: '18px',
                    background: index < 3 ? 'rgb(21, 101, 192)' : '#ccc',
                    color: '#fff',
                    borderRadius: '2px',
                  }}
                >
                  {index + 1}
                </Box>
                <Box sx={{ color: '#333' }}>{item.name || '-'}</Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
